import { render } from "./CognateSearch.vue?vue&type=template&id=4a7f7822&scoped=true"
import script from "./CognateSearch.vue?vue&type=script&lang=js"
export * from "./CognateSearch.vue?vue&type=script&lang=js"

import "./CognateSearch.vue?vue&type=style&index=0&id=4a7f7822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7f7822"]])

export default __exports__